import { PromosStylesSchema } from './Promos.styles';

export const promosStyles: PromosStylesSchema = {
  body: {
    color: 'gray.700',
  },
  container: {
    mx: '-1',
    mt: '-2',
  },
};
